import { useMemo } from 'react';
import moment from 'moment-timezone';

import { TextField, Autocomplete } from '@mui/material';

import { useTranslate } from 'src/locales';

// ----------------------------------------------------------------------

interface TimezoneAutocompleteProps {
  value: string;
  onChange: (timezone: string) => void;
  label?: string;
  size?: 'small' | 'medium';
  disabled?: boolean;
  fullWidth?: boolean;
}

/** "Australia/Melbourne (GMT+11:00)", with the offset as it stands today. */
export const formatTimezoneLabel = (timezone: string) => `${timezone} (GMT${moment.tz(timezone).format('Z')})`;

export default function TimezoneAutocomplete({
  value,
  onChange,
  label,
  size = 'small',
  disabled = false,
  fullWidth = true,
}: TimezoneAutocompleteProps) {
  const { t } = useTranslate();

  const options = useMemo(() => moment.tz.names(), []);

  return (
    <Autocomplete
      size={size}
      disabled={disabled}
      fullWidth={fullWidth}
      disableClearable
      options={options}
      value={value}
      getOptionLabel={formatTimezoneLabel}
      noOptionsText={t('components.timezone_autocomplete.no_options')}
      onChange={(_event, next) => {
        if (next) onChange(next);
      }}
      renderInput={(params) => (
        <TextField {...params} label={label ?? t('components.timezone_autocomplete.label')} />
      )}
    />
  );
}
